"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatOption = void 0;
var react_1 = require("react");
var isDisplayable = function (item) {
    return typeof item === "string" || typeof item === "number" || react_1.isValidElement(item);
};
// FORMATTING
var formatOption = function (option) {
    if (isDisplayable(option.label)) {
        return option.label;
    }
    else if (isDisplayable(option.item)) {
        // If item can be rendered, then prefer that
        return option.item;
    }
    else if (isDisplayable(option.value)) {
        // Otherwise fall back to value
        return option.value;
    }
    else {
        return undefined;
    }
};
exports.formatOption = formatOption;
//# sourceMappingURL=SelectUtils.js.map